import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import _ from "lodash";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx-js-style';
import { Dropdown } from "../components/Dropdown";
import MultiLineChart from "../components/lineChart";
import { useLogout } from "../common/logout";
import useDocumentTitle from "../common/useDocumentTitle";

const { REACT_APP_API_URI } = process.env;

const Productivity = () => {
  useDocumentTitle("삼성중공업 - 생산성시스템")
  const [activePeriod, setActivePeriod] = useState("month");
  const [activeType, setActiveType] = useState("비용");
  const [activeType2, setActiveType2] = useState("프로젝트명");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [optionList, setOptionList] = useState([]);

  const [plaindata, setPlainData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [tableData, setTableData] = useState({});
  const [quantity, setQuantity] = useState(0);
  const [productivity, setProductivity] = useState("");

  const logout = useLogout();


  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");


  const [filterOption, setFilterOption] = useState({
    project: "전체",
    area1: "전체",
    area2: "전체",
    construction1: "전체",
    construction2: "전체",
    step: "전체",
    job: "전체",
    vendor:"전체",
    dateRange: default_date,
  });


  const tableUnit = activeType === "비용" ? "KRW" : (filterOption.step === "전체" && activeType === "물량") ? "KRW" : filterOption.step.split("(")[1].split(")")[0]

  const [projectnumber, setProjectnumber] = useState("");

  const [isApply, setIsApply] = useState(false)

  const filterEl = useRef();
  const modalEl = useRef();

  useEffect(() => {
    // 클릭 이벤트 핸들러 함수
    const handleClickOutside = (event) => {
      const select_body = window.document.querySelector("#root");
      const isInsideModal = modalEl?.current?.contains(event.target);
      const isInsideFilter = filterEl?.current?.contains(event.target)

      if (isDropdownOpen && !isInsideModal && select_body.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      if (!isDropdownOpen && (isInsideFilter || !select_body.contains(event.target))) {
        setIsDropdownOpen(true);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };

  }, [modalEl, filterEl, isDropdownOpen]);


  useEffect(() => {
    const sendRequest = async () => {
      const response = await axios.get(`${REACT_APP_API_URI}/options`);
      setOptionList(response.data.data);
    };
    sendRequest();

  }, []);

  useEffect(() => {
    const sendRequest = async () => {
      const response = await axios.get(`${REACT_APP_API_URI}/productivity`, {
        params: {
          filterOption: filterOption,
        },
      }
      );


      // 1단계: 응답 데이터 변환
      const data = response.data.data.map((v) => ({
        "프로젝트 코드": v.project_projectnumber,
        "프로젝트명": v.project_projectname,
        "액티비티": v.uuu_P6ActivityId,
        "층": v.WBSCodeNMLv2,
        "Room": v.WBSCodeNMLv3,
        "대공종": v.WBSCodeNMLv4,
        "중공종": v.WBSCodeNMLv5,
        "날짜": v.ReportingDO,
        "업체명": v.uveVendorNameTB50,
        "직종": v.job,
        "투입공수": v.final_people,
        "작업 종류": v.step,
        "작업 물량": v.PALActualQty,
        "작업 단위": v.ugenUnitofMeasurePD,
        "비용": isNaN(v.weight) ? 0 : v.weight,
      }));



      ///직종이 전체인 경우
      const allDataPre = _(activeType === "물량" ?
      data.map((v)=>({...v, group:v.프로젝트명+v.날짜+v["작업 종류"],uniq:v.프로젝트명+v.액티비티+v.날짜+v["작업 종류"]})) :
      data.map((v)=>({...v, group:v.프로젝트명+v.날짜+v["작업 종류"], uniq:v.프로젝트명+v.액티비티+v.날짜})))
      .groupBy("uniq")
      .map((objs, key) => ({
        "프로젝트 코드": objs[0]["프로젝트 코드"],
        "프로젝트명": objs[0]["프로젝트명"],
        "액티비티":objs[0]["액티비티"],
        "층": objs[0]["층"],
        "Room": objs[0]["Room"],
        "대공종": objs[0]["대공종"],
        "중공종": objs[0]["중공종"],
        "날짜": objs[0]["날짜"],
        "업체명": objs[0]["업체명"],
        "직종":objs[0]["직종"],
        "투입공수": _.sumBy(objs, "투입공수"), 
        "작업 종류": objs[0]["작업 종류"],
        "작업 물량": _.maxBy(objs, "작업 물량")["작업 물량"], 
        "작업 단위":objs[0]["작업 단위"],
        "비용":_.maxBy(objs, "비용").비용, 

      }))
      .value();

      console.log(allDataPre)

      const startData = filterOption.job === "전체"?allDataPre:data


      // 2단계: 프로젝트별 데이터 그룹화 및 날짜별 합산
      const groupedData = activeType2 === "프로젝트명" ? startData.filter(v => v["투입공수"] > 0).reduce((acc, item) => {
        const projectCode = item[activeType2];
        if (!acc[projectCode]) {
          acc[projectCode] = {
            projectName: item[activeType2],
            rawData: [] // rawData를 추가하여 원본 데이터 저장
          };
        }

        const value = activeType === "물량" ? item["작업 물량"] : item["비용"];
        const numericValue = parseFloat(value); // 문자열을 숫자로 변환
        const validatedValue = isNaN(numericValue) ? 0 : numericValue; // NaN 검사 및 대체

        acc[projectCode].rawData.push({
          date: new Date(item["날짜"]).getTime(),
          quantityValue: validatedValue, // 수정된 값 사용
          manhourValue: isNaN(item["투입공수"]) ? 0 : item["투입공수"],
        });

        return acc;
      }, {}) :


      startData.filter(v => v["투입공수"] > 0).reduce((acc, item) => {
          const projectCode = item[activeType2];
          if (!acc[projectCode]) {
            acc[projectCode] = {
              projectName: item[activeType2],
              rawData: [] // rawData를 추가하여 원본 데이터 저장
            };
          }

          const value = activeType === "물량" ? item["작업 물량"] : item["비용"];
          const numericValue = parseFloat(value); // 문자열을 숫자로 변환
          const validatedValue = isNaN(numericValue) ? 0 : numericValue; // NaN 검사 및 대체

          acc[projectCode].rawData.push({
            date: new Date(item["날짜"]).getTime(),
            quantityValue: validatedValue, // 수정된 값 사용
            manhourValue: isNaN(item["투입공수"]) ? 0 : item["투입공수"],
          });

          return acc;
        }, {});



      // 날짜별로 데이터 그룹화 및 합산 로직을 각 프로젝트 데이터에 적용
      Object.values(groupedData).forEach(project => {
        const groupedByDate = _.groupBy(project.rawData, 'date');
        console.log(groupedByDate)

        project.data = Object.keys(groupedByDate).map(date => {
          const items = groupedByDate[date];

          console.log(items)

          const quantitySum = 
           _.sumBy(items, "quantityValue");
          const manhourSum = _.sumBy(items, 'manhourValue');
          return {
            date: parseInt(date),
            quantityValue: quantitySum,
            manhourValue: manhourSum
          };
        });

        // 날짜별로 정렬
        project.data.sort((a, b) => a.date - b.date);
      });


      // "전체" 데이터 계산을 위해 모든 rawData를 합침
      const combinedRawData = [].concat(...Object.values(groupedData).map(project => project.rawData));

      // "전체" 데이터에 대한 날짜별 데이터 그룹화 및 합산
      const groupedByDateAll = _.groupBy(combinedRawData, 'date');

      const allData = Object.keys(groupedByDateAll).map(date => {
        const items = groupedByDateAll[date];
        const quantitySum =   _.sumBy(items, 'quantityValue');
        const manhourSum = _.sumBy(items, 'manhourValue');
        return {
          date: parseInt(date),
          quantityValue: quantitySum,
          manhourValue: manhourSum
        };
      });
      allData.sort((a, b) => a.date - b.date);


      // 4단계: 데이터 포인트 채우기
      const getDatesInRange = (startDate, endDate) => {
        const dates = [];
        let currentDate = new Date(startDate);
        endDate = new Date(endDate);

        while (currentDate <= endDate) {
          dates.push(new Date(currentDate));
          currentDate.setDate(currentDate.getDate() + 1);
        }

        return dates;
      };

      const fillDataPoints = (projectData, startDate, endDate) => {
        const allDates = getDatesInRange(startDate, endDate);

        return allDates.map(date => {
          const dateTimestamp = date.getTime();
          const existingData = projectData.find(item => item.date === dateTimestamp);
          return existingData || { date: dateTimestamp, value: 0 };
        });
      };

      Object.values(groupedData).forEach(project => {
        if (project.data.length > 0) {
          const startDate = project.data[0].date;
          const endDate = project.data[project.data.length - 1].date;
          project.data = fillDataPoints(project.data, startDate, endDate);
        }
      });


      const startDateAll = allData && allData[0] && allData[0].date;
      const endDateAll = allData && allData[allData.length - 1] && allData[allData.length - 1].date;

      // 5단계: 최종 차트 데이터 구성
      const chartPropsDataArray =
        filterOption.project === "전체" || activeType2 === "업체명" ?
          Object.values(groupedData).map(project => ({
            projectName: project.projectName,
            data: project.data
          })).concat([{
            projectName: "전체",
            data: fillDataPoints(allData, startDateAll, endDateAll) // "전체" 데이터에 대한 포인트 채우기 적용
          }]) :
          Object.values(groupedData).map(project => ({
            projectName: project.projectName,
            data: project.data
          }));


      setChartData(chartPropsDataArray);
      setPlainData(data);

      console.log(chartPropsDataArray)



      // const totalcost =_.sumBy(      
      // data.map((v)=>({...v, group:v.프로젝트명+v.날짜+v["작업 종류"], uniq:v.프로젝트명+v.액티비티+v.날짜})), "비용")
      
      
      // const totalQty =_.sumBy( _.uniqBy(data.map((v)=>({...v, uniq:v.프로젝트명+v.액티비티+v.날짜+v["작업 종류"]})), "uniq" ) , "작업 물량");

      const productivityByJob = data.filter(v => v["투입공수"] > 0).reduce((acc, curr) => {
        const job = curr["직종"];

        if (!acc[job]) {
          acc[job] = { totalQty: 0, totalPeople: 0 };
        }

        if (activeType === "물량") {
          acc[job].totalQty += curr["작업 물량"];
        } else {
          acc[job].totalQty += curr["비용"];
        }
        acc[job].totalPeople += curr["투입공수"];

        return acc;
      }, {});
      
      const totalValue = activeType === "물량"?_.sumBy( _.uniqBy(data.map((v)=>({...v, uniq:v.프로젝트명+v.액티비티+v.날짜+v["작업 종류"]})), "uniq" ) , "작업 물량"):_.sumBy( _.uniqBy(data.map((v)=>({...v, uniq:v.프로젝트명+v.액티비티+v.날짜+v["작업 종류"]})), "uniq" ) , "비용")

      const tableQtyValue = activeType === "물량"?_.sumBy( _.uniqBy(data.map((v)=>({...v, uniq:v.프로젝트명+v.액티비티+v.날짜+v["작업 종류"]})), "uniq" ) , "작업 물량"):_.sumBy( _.uniqBy(data.map((v)=>({...v, uniq:v.프로젝트명+v.액티비티+v.날짜+v["작업 종류"]})), "uniq" ) , "비용")

      setQuantity(tableQtyValue)

      // 직종별 생산성 계산
      Object.keys(productivityByJob).forEach(job => {
        const { totalPeople } = productivityByJob[job];
        productivityByJob[job].productivity = totalPeople > 0 ? (totalValue)/ totalPeople : 0;
      });

      // "투입공수"이 큰 순서로 정렬, 생산성 정보를 유지
      const sortedEntries = Object.entries(productivityByJob).sort((a, b) => {
        return b[1].totalPeople - a[1].totalPeople;
      });

      // "투입공수"이 큰 순서로 정렬된 데이터에서 productivity 값만 포함하여 객체 재구성
      const finalDataWithProductivityOnly = sortedEntries.reduce((acc, [job, data]) => {
        // 각 직종별로 productivity와 manhour 값을 저장
        acc[job] = {
          productivity: data.productivity,
          manhour: data.totalPeople,
          totalQty: data.totalQty
        };
        return acc;
      }, {});


      setTableData(finalDataWithProductivityOnly);



      // 총합 초기화
      let totalQtySum = 0;
      let manhourSum = 0;

      // 각 객체의 totalQty 및 manhour 값을 총합에 더함
      for (const key in finalDataWithProductivityOnly) {
        totalQtySum += finalDataWithProductivityOnly[key].totalQty;
        manhourSum += finalDataWithProductivityOnly[key].manhour;
      }




      setProductivity(
        activeType === "물량" ?
          (totalValue / manhourSum).toFixed(2) + " " + data[0]["작업 단위"] + "/ MH" :
          (totalValue / manhourSum).toFixed(0) + " KRW / MH"
      )
    };

    sendRequest();
    setStart(dayjs(filterOption.dateRange.start).format("YYYY-MM-DD"));
    setEnd(dayjs(filterOption.dateRange.end).format("YYYY-MM-DD"));

    if (filterOption.step === "전체" && activeType === "물량") {
      Swal.fire({
        title: '',
        text: '현재 선택한 필터는 하나의 종류의 작업이 아니므로 비용으로만 계산됩니다.',
        icon: 'warning',
      })
      setIsApply(true)

    }

  }, [filterOption, activeType, activeType2]);



  const handleSaveClick = () => {
    const ws = XLSX.utils.json_to_sheet(plaindata);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `productivity.xlsx`);
  };
  useEffect(() => {
    if (isApply) setIsDropdownOpen(false)
    setIsApply(false)
  }, [isApply])

  return (
    <div>
<nav className="navbar justify-content-between">
  <div className="d-flex align-items-center">
    <div className="navbar-brand" style={{ marginTop: "-2px" }}>
      <img src="/samsung_logo_right.png" width="200" height="35" className="d-inline-block align-top" style={{ marginLeft: "70px", marginTop: "30px" }} alt="" />
    </div>
    <h4 className="fs-1 text-gray-800 w-bolder mt-12 mx-5">하이테크 사업부 생산성 분석</h4>
  </div>
  <div className="d-flex align-items-center gap-2 gap-lg-3 mx-20">
    <span className="btn btn-sm fw-bold btn-primary" onClick={logout}>로그아웃</span>
  </div>
</nav>


      <div className="row gy-scroll5 g-xl-10 mx-20 mt-0 my-12">
        <div className="col-xl-3 mb-xl-10">
          <div className="card h-md-40 mb-xl-5" data-bs-theme="light">
            <div className="card-header border-0 pt-5 ">
              <h3 className="card-title align-items-start flex-column">
                <span className="card-label fw-bold fs-3">
                  생산성 분석 대상 조건 선택
                </span>
              </h3>
              <div className="card-toolbar mb-5" ref={filterEl} >
                <button
                  type="button"
                  className="btn btn-sm btn-flex btn-light fw-bold"
                // onClick={handleToggleDropdown}
                // style={{marginRight: "10px"}}
                >
                  Filter
                </button>
                {isDropdownOpen ? (
                  <div
                    className="d-flex align-items-center gap-2 gap-lg-3"
                    style={{ marginTop: "-85px" }}
                    ref={modalEl}
                  >
                    <div className="m-0">
                      <Dropdown
                        optionList={optionList}
                        activeType2={activeType2}
                        filterOption={filterOption}
                        isDropdownOpen={isDropdownOpen}
                        setIsDropdownOpen={setIsDropdownOpen}
                        setFilterOption={setFilterOption}
                        default_date={default_date}
                        // projectList={projectList}
                        projectnumber={projectnumber}
                        setProjectnumber={setProjectnumber}
                        isApply={false}
                        setIsApply={setIsApply}
                      // totalMeasure={totalMeasure}
                      // setTotalMeasure={setTotalMeasure}
                      />
                    </div>
                  </div>
                ) : <></>}
              </div>
            </div>
            <div className="card-body scroll h-280px pt-0 pb-0">
              <div className="d-flex align-items-center bg-light rounded p-4 mb-5">
                <div className="flex-grow-1 me-2 mx-5">
                  <span className="fw-bold text-gray-700 fs-4">
                    {filterOption.project}
                  </span>
                </div>
                <span className="fw-bold text-muted py-1">Project</span>
              </div>
              <div className="d-flex align-items-center bg-light rounded p-4 mb-5">
                <div className="flex-grow-1 me-2 mx-5">
                  <span className="fw-bold text-gray-700 fs-4">
                    {filterOption.vendor}
                  </span>
                </div>
                <span className="fw-bold text-muted py-1">업체명</span>
              </div>
              <div className="d-flex align-items-center bg-light rounded p-4 mb-5">
                <div className="flex-grow-1 me-2 mx-5">
                  {filterOption.area1 === "전체" ? (
                    <span className="fw-bold text-gray-700 fs-4">
                      {filterOption.area1}
                    </span>
                  ) : (
                    <>
                      <span className="fw-bold text-gray-700 fs-4">
                        {filterOption.area1}
                      </span>
                      <span className="fw-bold text-gray-700 fs-4 mx-2">-</span>
                      <span className="fw-bold text-gray-700 fs-4 mx-2">
                        {filterOption.area2}
                      </span>
                    </>
                  )}
                </div>
                <span className="fw-bold text-muted py-1">Area</span>
              </div>
              <div className="d-flex align-items-center bg-light rounded p-4 mb-5">
                <div className="flex-grow-1 me-2 mx-5">
                  {filterOption.construction1 === "전체" ? (
                    <span className="fw-bold text-gray-700 fs-4">
                      {filterOption.construction1}
                    </span>
                  ) : (
                    <>
                      <span className="fw-bold text-gray-700 fs-4">
                        {filterOption.construction1}
                      </span>
                      <span className="fw-bold text-gray-700 fs-4 mx-2">-</span>
                      <span className="fw-bold text-gray-700 fs-4 mx-2">
                        {filterOption.construction2}
                      </span>
                    </>
                  )}
                </div>
                <span className="fw-bold text-muted py-1">공종</span>
              </div>
              <div className="d-flex align-items-center bg-light rounded p-4 mb-5">
                <div className="flex-grow-1 me-2 mx-5">
                  <span className="fw-bold text-gray-700 fs-4">
                    {filterOption.step}
                  </span>
                </div>
                <span className="fw-bold text-muted py-1">작업 종류</span>
              </div>
              <div className="d-flex align-items-center bg-light rounded p-4 mb-5">
                <div className="flex-grow-1 me-2 mx-5">
                  <span className="fw-bold text-gray-700 fs-4">
                    {filterOption.job}
                  </span>
                </div>
                <span className="fw-bold text-muted py-1">직종</span>
              </div>
            </div>
          </div>
     <div className="card h-md-40" data-bs-theme="light">
            <div className="card-header border-0 pt-5">
              <h3 className="card-title align-items-start">
                <span className="card-label fw-bold fs-3">생산성 분석 결과</span>
                <span className="fw-bold text-muted py-1">{quantity && quantity.toLocaleString()}</span>
              </h3>
            </div>

            <div className="card-body scroll h-250px pt-0 pb-0">
              {chartData.length > 0 &&
                <div>
                  {Object.keys(tableData).map((key) => (
                    <div
                      key={key}
                      className="d-flex align-items-center bg-light rounded p-3 mb-4"
                    >
                      <div className="flex-grow-1 me-2 mx-5">
                        <span className="fw-bold text-gray-700 fs-2">
                          {activeType === "물량" ? Number(tableData[key].productivity).toFixed(3) : Number(tableData[key].productivity.toFixed(0)).toLocaleString()}
                        </span>
                        <span className="fs-6 fw-semibold text-gray-400 mx-2">
                          {tableUnit}/MH
                        </span>
                        <span className="fs-6 fw-semibold text-gray-400 mx-2">
                          {activeType === "물량" ? tableData[key].manhour.toFixed(3) : Number(tableData[key].manhour.toFixed(0)).toLocaleString()}
                        </span>
                      </div>
                      <span className="fw-bold text-muted py-1">{key}</span>
                    </div>
                  ))}
                </div>
              }
            </div>
          </div>
        </div>
        <div className="col-xl-9 mb-5 mb-xl-10">
          <div className="card h-md-100">
            <div className="card-header border-0 pt-5 m-5 mb-0">
              <h3 className="card-title align-items-start ">
                <span className="card-label fw-bold fs-3 pb-0">
                  기간별 생산성 추이
                </span>
                <span className="card-label text-gray-800 fs-6 pt-1">
                  {start} ~ {end}
                </span>
              </h3>
              <div className="card-toolbar" data-kt-buttons="true">
                <ul className="nav">

                  <li className="nav-item">
                    <span
                      className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 ${activeType2 === "프로젝트명" ? "active" : ""
                        }`}
                      onClick={() => setActiveType2("프로젝트명")}
                    >
                      프로젝트 View
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 ${activeType2 === "업체명" ? "active" : ""
                        }`}
                      onClick={() => setActiveType2("업체명")}
                    >
                      협력사 View
                    </span>
                  </li>
                </ul>
                <div className="vr m-5" />

                <ul className="nav">

                  <li className="nav-item">
                    <span
                      className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 ${activeType === "물량" ? "active" : ""
                        }`}
                      onClick={() => setActiveType("물량")}
                    >
                      물량
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 ${activeType === "비용" ? "active" : ""
                        }`}
                      onClick={() => setActiveType("비용")}
                    >
                      비용
                    </span>
                  </li>
                </ul>
                <div className="vr m-5" />
                <ul className="nav">
                  <li className="nav-item">
                    <span
                      className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light fw-bold px-4 me-1 ${activePeriod === "day" ? "active" : ""
                        }`}
                      onClick={() => setActivePeriod("day")}
                    >
                      Day
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link btn btn-sm text-muted btn-active btn-active-light fw-bold px-4 me-1 ${activePeriod === "week" ? "active" : ""
                        }`}
                      onClick={() => setActivePeriod("week")}
                    >
                      Week
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light fw-bold px-4 me-1 ${activePeriod === "month" ? "active" : ""
                        }`}
                      onClick={() => setActivePeriod("month")}
                    >
                      Month
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link btn btn-sm btn-color-secondary fw-bold px-4 me-1`}
                      onClick={handleSaveClick}
                    >
                      <i className="ki-duotone ki-file-down fs-1 text-muted">
                        <span className="path1"></span>
                        <span className="path2"></span>
                      </i>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body mx-5">
              <div className="mb-10">
                <span className="fs-2hx fw-bold d-block text-gray-800 me-2 mb-2 lh-1 ls-n1">
                  { chartData.length > 0 &&
                  Number(productivity.split(" ")[0]).toLocaleString()}
                  <span className="fs-6 fw-semibold text-gray-400 mx-5">
                  { chartData.length > 0 && productivity.split(" ").slice(1).join(" ")}
                  </span>
                </span>
              </div>
              <div className="ms-n5 me-n3 min-h-auto w-100">
                {chartData.length > 0 &&
                  <MultiLineChart chartData={chartData} activePeriod={activePeriod} productivity={productivity} activeType={activeType} />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productivity;

const default_date = {
  start: new Date(dayjs().add(-6, "months").format("YYYY-MM-DD 00:00:00")),
  end: new Date(dayjs().format("YYYY-MM-DD 00:00:00")),
};

